import { useController } from 'react-hook-form'
import { useIntlMemo } from 'hooks/intl'
import Layout from '../components/controls/Layout'

export default function YesNo({ props }) {
    const { name, label, description } = props
    const { field } = useController({ name })
    const options = useOptions()

    return (
        <Layout name={name} description={description}>
            <label>{label}</label>
            {Array.from(options, ([value, display], index) => (
                <label key={index}>
                    <input
                        type="radio"
                        {...field}
                        value={value}
                        defaultChecked={field.value === value}
                    />
                    {display}
                </label>
            ))}
        </Layout>
    )
}

// Utils
function useOptions() {
    return useIntlMemo(
        intl =>
            new Map([
                [true, intl.formatMessage({ id: 'yes', defaultMessage: 'Yes' })],
                [false, intl.formatMessage({ id: 'no', defaultMessage: 'No' })],
            ])
    )
}
